
<header class="hero-header">
    <h1>{{'Privacy Policy'| translate}}</h1>
    <h3>{{'Privacy Policy'| translate}}</h3>
</header>
<div class="body">
<h1>{{'Privacy Policy'}}</h1>

<h2>Lorem ipsum dolor sit amet, consectetur adipiscing elit, </h2>
<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.”</p>
</div>

